import { render, staticRenderFns } from "./RoomServiceGroupFormDialog.vue?vue&type=template&id=7b2264d4"
import script from "./RoomServiceGroupFormDialog.vue?vue&type=script&lang=js"
export * from "./RoomServiceGroupFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports